import { Prefs } from "~/alias/prefs";
import { License } from "~/picreplacement/check";
import * as ewe from "@eyeo/webext-ad-filtering-solution";
export async function getFacts() {
    await Promise.all([Prefs.untilLoaded, License.ready()]);
    return {
        hasPremium: await License.isActiveLicense(),
        installDate: Prefs.get("installDate"),
        blockedCount: Prefs.get("blocked_total"),
        reverseTrialStartDate: Prefs.get("reverse_trial_start_date"),
    };
}
export function start() {
    License.licenseNotifier.on("license.status.changed", ewe.remoteConfig.updateFacts);
    Prefs.on("installDate", ewe.remoteConfig.updateFacts);
}
